const businessConfig = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_BUSINESS_CONFIG_SUCCESS':
      return action.businessConfig
    default:
      return state
  }
}

export default businessConfig

export const selectBusinessConfig = (state) => {
  return state.businessConfig || []
}
